import { handleActions } from 'redux-actions';
import randomColor from 'randomcolor';

const generateRandomColor = () => randomColor({ luminosity: 'bright', format: 'rgb' });

const defaultState = {
  evaluating: false,
  instanceSize: 'all',
  evaluationCategory: 'person',
  evaluationCategorySn: 1,
  evaluations: [],

  evaluationInstances: []

  // recall: [],
  // ap: [],
  // lamr: [],
  // PRCurve: [],
  // interpolatedPRCurve: [],
  // MRFPPICurve: []
};

const handleEvaluateStart = state => ({
  ...state,
  evaluating: true
});
const handleEvaluateSuccess = state => ({
  ...state,
  evaluating: false
});

const handleAppendEvaluation = (state, { payload }) => {
  const { response, model } = payload;

  console.log(response, model);

  return {
    ...state,
    evaluations: [
      ...state.evaluations,
      { ...response, model: { ...model, color: generateRandomColor() } }
    ]
  };
};

const handleClearEvaluation = state => ({
  ...state,
  evaluations: []
});

// const handleUpdateEvaluation = (state, { payload }) => {
//   console.log(payload);
//   return {
//     ...state
//   };
// };

const handleUpdateInstanceSize = (state, { payload }) => ({
  ...state,
  instanceSize: payload
});

const handleUpdateModelInstance = (state, { payload }) => {
  const { eval_instances: evaluationInstances } = payload;

  return ({
    ...state,
    evaluationInstances
  });
};

const handleClearModelInstance = state => ({
  ...state,
  evaluationInstances: []
});

export default handleActions(
  {
    EVALUATE_START: handleEvaluateStart,
    EVALUATE_SUCCESS: handleEvaluateSuccess,
    CLEAR_EVALUATION: handleClearEvaluation,
    APPEND_EVALUATION: handleAppendEvaluation,
    // UPDATE_EVALUATION: handleUpdateEvaluation,
    UPDATE_INSTANCE_SIZE: handleUpdateInstanceSize,
    // EVALUATE_MODEL_INSTANCE: handleEvaluateModelInstance,
    UPDATE_MODEL_INSTANCE: handleUpdateModelInstance,
    CLEAR_MODEL_INSTANCE: handleClearModelInstance
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/reducers/EvaluationReducer.js